<template>
    <div class="Knn" :class="{ disable : disable }">  
      <video class="Knn__video" id="video" playsinline style="
            -webkit-transform: scaleX(-1);
            transform: scaleX(-1);
            visibility: auto;
            width: auto;
            height: auto;
            position: absolute;">
        </video>
      <div class="Knn__hand ">{{ msg }}</div>
      <div class="Knn__hand right">{{ res }}</div>  

      <div class="Knn__examples">
        <img id="sq1" :src="require('@/commons/img/sq1.png')"/>
        <img id="sq2" :src="require('@/commons/img/sq2.png')"/>
        <img id="sq3" :src="require('@/commons/img/sq3.png')"/>
        <img id="sq4" :src="require('@/commons/img/sq4.png')"/>
        <img id="sq5" :src="require('@/commons/img/sq5.png')"/>
        <img id="hu1" :src="require('@/commons/img/hu1.png')"/>
        <img id="hu2" :src="require('@/commons/img/hu2.png')"/>
        <img id="hu3" :src="require('@/commons/img/hu3.png')"/>
      </div>

    </div>
</template>

<script>

import gsap from "gsap"
import * as mobilenetModule from '@tensorflow-models/mobilenet'

import * as tf from '@tensorflow/tfjs-core'
import '@tensorflow/tfjs-backend-cpu'
import '@tensorflow/tfjs-backend-webgl'
import Stats from 'stats.js'
import * as knnClassifier from '@tensorflow-models/knn-classifier'

export default {

  name: 'Knn',
  render: h => h(), 
  data: ()=>({

   msg: 'loading model',
   res: '***',
   cn1: 0,
   cn2: 0

  }),
  beforeDestroy() {
    if(this.rafID)
      cancelAnimationFrame(this.rafID)
  },
  mounted() {
    console.log('Knn');
    this.$nextTick(()=>{
      this.init()
    })
  },

  methods: {

    setupCamera: async function() {
      
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        throw new Error(
            'Browser API navigator.mediaDevices.getUserMedia not available')
      }

      const video = document.getElementById('video')
      const stream = await navigator.mediaDevices.getUserMedia({
        'audio': false,
        'video': {
          facingMode: 'user',
          // Only setting the video to a specified size in order to accommodate a
          // point cloud, so on mobile devices accept the default size.
          width: 320,
          height: 240
        },
      })

      video.srcObject = stream

      return new Promise((resolve) => {
        video.onloadedmetadata = () => { resolve(video) }
      })
    },

    loadVideo: async function() {
      const video = await this.setupCamera()
      video.play()
      return video
    },

    addTraining: async function(sample, range) {  

      this.msg = 'training model '+ sample

      const id = document.getElementById(sample)
      const image = tf.browser.fromPixels(id)

      console.log(image);

      const infer = () => this.$mobilenet.infer(image, 'img_'+ sample);
      let logits = infer()

      console.log(logits);
      console.log('xxxxx !');

      this.$classifier.addExample(logits, range)
      image.dispose()
      logits.dispose()

      return new Promise((resolve) => { 
        gsap.delayedCall(.35, ()=> resolve())
      })
       
    },

    init: async function() {
      
      let video
      this.$classifier = knnClassifier.create()
      this.$mobilenet = await mobilenetModule.load()

      console.log(this.$classifier.getNumClasses());

      try {

        video = await this.loadVideo()

        await this.addTraining('sq1', 0)
        await this.addTraining('sq2', 0)
        await this.addTraining('sq3', 0)
        await this.addTraining('sq4', 0)
        await this.addTraining('sq5', 0)
        await this.addTraining('hu1', 1)
        await this.addTraining('hu2', 1)
        await this.addTraining('hu3', 1)

        console.log(this.$classifier);

        this.msg = 'training model completed'
        this.onLoop()

      } catch (e) {
   
        //  console.log('catch '+ e);
        throw e
      }

    },


    onLoop: async function() {

      const image = tf.browser.fromPixels(document.getElementById('video'))
      let logits
      const infer = () => this.$mobilenet.infer(image, 'video')
      logits = infer()

      const res = await this.$classifier.predictClass(logits, 2)
      const classExampleCount = this.$classifier.getClassExampleCount()


      if(res.confidences[0]> .5){
        // console.log('SQUAT');
        this.cn1 += 1
        this.cn2 = 0
        if(this.cn1 > 5)
          this.res = 'SQUAT'
      }
      else if(res.confidences[1]> .5){
        // console.log('DEBOUT');

        this.cn2 += 1
        this.cn1 = 0
        if(this.cn2 > 5)
          this.res = 'DEBOUT' 
      }
      else{
        this.res = '***'
        this.cn1 = 0
        this.cn2 = 0
        // console.log('***');
      }

      image.dispose()
      if (logits != null) 
        logits.dispose()
      
      this.rafID = requestAnimationFrame(this.onLoop)       
    },
 
    // motionLeft() {
    //   if(this.lft_locked == true)
    //     return
    //   this.lft_locked = true
    //   this.$store.commit('app/MOTION_LEFT')
    //   gsap.delayedCall(.5, ()=>{ this.lft_locked = false })
    // },
    
  }
}
</script>

<style lang="stylus">

@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Knn
  position absolute 
  top 0 
  left 0
  width 100vw
  height 100vh
  // overflow hidden

  &__hand 
    position absolute
    border 1px solid red
    padding 4px 16px
    width 300px
    background red
    text-align center
    height 27px

    &.right 
      right 0

  &__video 
    top 50px
    right 13px

  &__examples
    display flex 
    flex-direction column
    width 320px
    padding-top 50px
    padding-left 13px

   
</style>















